// ============================================================
//  api.js — كل الاتصالات بالـ Backend
//  عدّل هذا السطر فقط:
// ============================================================
const BASE = process.env.REACT_APP_API_URL;

async function call(method, path, body) {
  const token = localStorage.getItem("school_token") || "";
  try {
    const r = await fetch(BASE + path, {
      method,
      headers: {
        "Content-Type":  "application/json",
        "Authorization": "Bearer " + token,
      },
      body: body !== undefined ? JSON.stringify(body) : undefined,
    });
    const d = await r.json();
    if (r.status === 401) {
      localStorage.clear();
      window.location.reload();
    }
    return d;
  } catch {
    return { success: false, message: "تعذّر الاتصال بالسيرفر" };
  }
}

const G = (path)       => call("GET",    path);
const P = (path, body) => call("POST",   path, body);
const U = (path, body) => call("PUT",    path, body);
const D = (path)       => call("DELETE", path);
const QS = (p)         => new URLSearchParams(p || {}).toString();

const api = {
  // ── Auth ────────────────────────────────────────────────
  login: (u, p) => P("/api/auth.php", { username: u, password: p }),

  // ── Students ────────────────────────────────────────────
  students: {
    list:   (p)    => G("/api/students.php?"    + QS(p)),
    get:    (id)   => G("/api/students.php?id=" + id),
    ledger: (id)   => G("/api/students.php?id=" + id + "&action=ledger"),
    add:    (d)    => P("/api/students.php",      d),
    edit:   (id,d) => U("/api/students.php?id=" + id, d),
    del:    (id)   => D("/api/students.php?id=" + id),
  },

  // ── Guardians ───────────────────────────────────────────
  guardians: {
    list: (p)    => G("/api/guardians.php?"    + QS(p)),
    get:  (id)   => G("/api/guardians.php?id=" + id),
    add:  (d)    => P("/api/guardians.php",      d),
    edit: (id,d) => U("/api/guardians.php?id=" + id, d),
  },

  // ── Payments ────────────────────────────────────────────
  payments: {
    list:   (p)    => G("/api/payments.php?" + QS(p)),
    add:    (d)    => P("/api/payments.php",  d),
    cancel: (id,r) => P("/api/payments.php?id=" + id + "&action=cancel", { reason: r }),
  },

  // ── Transport ───────────────────────────────────────────
  transport: {
    list:   ()     => G("/api/transport.php"),
    add:    (d)    => P("/api/transport.php?action=add",    d),
    remove: (d)    => P("/api/transport.php?action=remove", d),
    zone:   (id,d) => U("/api/transport.php?id=" + id,      d),
  },

  // ── Expenses ────────────────────────────────────────────
  expenses: {
    list: (p)    => G("/api/expenses.php?"    + QS(p)),
    cats: ()     => G("/api/expenses.php?action=cats"),
    add:  (d)    => P("/api/expenses.php",      d),
    edit: (id,d) => U("/api/expenses.php?id=" + id, d),
    del:  (id)   => D("/api/expenses.php?id=" + id),
  },

  // ── Payroll ─────────────────────────────────────────────
  payroll: {
    employees: ()     => G("/api/payroll.php"),
    month:     (m)    => G("/api/payroll.php?action=months&month=" + m),
    addEmp:    (d)    => P("/api/payroll.php",                d),
    editEmp:   (id,d) => U("/api/payroll.php?id=" + id,       d),
    paySalary: (d)    => P("/api/payroll.php?action=salary",  d),
  },

  // ── Settings ────────────────────────────────────────────
  settings: {
    get:  ()  => G("/api/settings.php"),
    save: (d) => U("/api/settings.php", d),
  },

  // ── Reports ─────────────────────────────────────────────
  reports: {
    students:  (p) => G("/api/reports.php?type=students&"  + QS(p)),
    transport: (p) => G("/api/reports.php?type=transport&" + QS(p)),
    unpaid:    (p) => G("/api/reports.php?type=unpaid&"    + QS(p)),
    financial: (p) => G("/api/financial_report.php?"       + QS(p)),
  },
};

export default api;
